import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import article.spring.SPRING_INTRO
import article.spring.SPRING_SCALE_BALL
import demos.animatedContent.BLURRED_NUMBER_CHANGE
import demos.buttons.*
import demos.`fun`.FOLLOWING_ARROWS
import demos.`fun`.THREE_D_CAROUSEL
import kotlinx.browser.document
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.HTMLStyleElement
import org.w3c.dom.url.URL
import playground.gradient.GRADIENT_PLAYGROUND


@OptIn(ExperimentalComposeUiApi::class)
fun main() {

    val id = URL(document.URL).searchParams.get("id") ?: "404"
//    val id = GRADIENT_PLAYGROUND

//    println("Hello main")

    val htmlHeadElement = document.head!!
    htmlHeadElement.appendChild(
        (document.createElement("style") as HTMLStyleElement).apply {
            type = "text/css"
            appendChild(
                document.createTextNode(
                    """
                    html, body {
                        overflow: hidden;
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    #canvas { outline: none; }
                    """.trimIndent()
                )
            )
        }
    )

    onWasmReady {
        CanvasBasedWindow("Demos") {
            MainView(id)
        }

//        browserViewportWindow("Demos") {
//            MainView(id)
//        }
    }
}